import React, { useEffect, useState } from "react";
import ApexChart from "../../ExtraComponents/ApexChart";
import { useDispatch } from "react-redux";
import { getDashboardData } from "../../ReduxStore/Slice/Dashboard/dashboardSlice";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs";
import { DatePicker, Space, theme } from 'antd';


const Dashboard = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("current-month");
  const [dashboard, setDashboard] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const agent_id = localStorage.getItem("agent_id");
  const [range, setRange] = useState(null);





  const DashboardData = async () => {
    let req = { agent_id: agent_id, filter: activeTab, link: "dashboard" };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        agent_id: agent_id,
        filter: activeTab,
        link: "dashboard",
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD"),
      };
    }
    await dispatch(getDashboardData(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setDashboard(response.data);
        } else {
          setDashboard([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };



  useEffect(() => {
    DashboardData();
  }, [activeTab, range]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };

  const seriesData = [10, 50, 30, 40, 70, 90, 120, 150, 200];
  const categories = ["1", "15", "30"];

  return (
    <>
      <div className="filter-select mb-3 select_tab">
        <div className=" d-flex">
          <select
            onChange={handleTabChange}
            value={activeTab}
            className="form-select"
          >
            <option value="current-month">Current Month</option>
            <option value="prev-month">Previous Month</option>
            <option value="current-quarter">Current Quarter</option>
            <option value="previous-quarter">Previous Quarter</option>
            <option value="current-calender-quarter">
              Current Calendar Year
            </option>
            <option value="prev-calender-year">Previous Calendar Year</option>
            <option value="custom-date">Custom Date</option>
          </select>
        </div>


        {activeTab === "custom-date" && (
          <div className=" d-flex gap-2 mt-2 mb-3">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateRangePicker"]}>
                <DatePicker.RangePicker
                  value={range}
                  onChange={setRange}
                  placeholder={['Start Date', 'End Date']}
                  format="DD/MM/YYYY"
                  className=""
                />
                {/* <DateRangePicker
                  localeText={{ start: "Check-in", end: "Check-out" }}
                  value={dateRange}
                  onChange={(newValue) => {
                    const formattedStartDate = newValue[0]
                      ? dayjs(newValue[0]).format("YYYY-MM-DD")
                      : null;
                    const formattedEndDate = newValue[1]
                      ? dayjs(newValue[1]).format("YYYY-MM-DD")
                      : null;

                    setStartDate(formattedStartDate);
                    setEndDate(formattedEndDate);
                    setDateRange(newValue);
                  }}
                /> */}
              </DemoContainer>
            </LocalizationProvider>
          </div>
        )}
      </div>

      <div id="my_content">
        <div className="col-md-12">
          <div>
            <section className="section dashboard">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row">
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Contracts sent</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.contractsSent || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.contractsSent_last || 0}
                                </span>
                              )}
                            </div>
                            <div>
                              {activeTab != "custom-date" && (
                                <div className="small">
                                  <i
                                    className={`fs-5 me-1 ${dashboard?.contractsSent >
                                      dashboard?.contractsSent_last
                                      ? "ri-arrow-up-circle-fill text-success"
                                      : dashboard?.contractsSent <
                                        dashboard?.contractsSent_last
                                        ? "ri-arrow-down-circle-fill text-danger"
                                        : "text-secondary"
                                      }`}
                                  ></i>
                                  {dashboard?.contractsSent_last &&
                                    dashboard?.contractsSent_last !== 0
                                    ? (
                                      ((dashboard?.contractsSent -
                                        dashboard?.contractsSent_last) /
                                        dashboard?.contractsSent_last) *
                                      100
                                    ).toFixed(2)
                                    : 0}
                                  %
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Contracts signed</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.contractsSigned || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.contractsSigned_last || 0}
                                </span>
                              )}
                            </div>
                            <div>
                              {activeTab != "custom-date" && (
                                <div className="small">
                                  <i
                                    className={`fs-5 me-1 ${dashboard?.contractsSigned >
                                      dashboard?.contractsSigned_last
                                      ? "ri-arrow-up-circle-fill text-success"
                                      : dashboard?.contractsSigned <
                                        dashboard?.contractsSigned_last
                                        ? "ri-arrow-down-circle-fill text-danger"
                                        : "text-secondary"
                                      }`}
                                  ></i>
                                  {dashboard?.contractsSigned_last &&
                                    dashboard?.contractsSigned_last !== 0
                                    ? (
                                      ((dashboard?.contractsSigned -
                                        dashboard?.contractsSigned_last) /
                                        dashboard?.contractsSigned_last) *
                                      100
                                    ).toFixed(2)
                                    : 0}
                                  %
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Awaiting signature</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.awaitingSignature || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.awaitingSignature_last || 0}
                                </span>
                              )}
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Unsent contracts</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.unsentContracts || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.unsentContracts_last || 0}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="card info-card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <h5 className="card-title">
                          Signed Value
                          {activeTab != "custom-date" && <div className=" small  ">
                            <i class="ri-arrow-up-circle-fill text-success fs-5 me-1"></i>
                            {dashboard?.signedValue_last &&
                              parseFloat(dashboard?.signedValue_last) !== 0
                              ? (
                                ((parseFloat(dashboard?.signedValue) -
                                  parseFloat(dashboard?.signedValue_last)) /
                                  parseFloat(dashboard?.signedValue_last)) *
                                100
                              ).toFixed(2)
                              : "0"}{" "}
                            %
                          </div>}
                        </h5>
                        <div className="pt-3">
                          <h6>£{dashboard?.signedValue}</h6>

                          {activeTab != "custom-date" && (
                            <span className="filter-text">
                              Last month: £{dashboard?.signedValue_last || 0}{" "}
                            </span>
                          )}
                        </div>
                      </div>
                      <ApexChart
                        seriesData={seriesData}
                        categories={categories}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
